var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.489258C6.26792 0.489258 0 6.75717 0 14.4893C0 22.2213 6.26792 28.4893 14 28.4893C21.7321 28.4893 28 22.2213 28 14.4893C28 6.75717 21.7321 0.489258 14 0.489258ZM10.5729 20.292H7.73792V11.1686H10.5729V20.292ZM9.13792 10.0486C8.2425 10.0486 7.66354 9.41426 7.66354 8.62967C7.66354 7.82905 8.26 7.21363 9.17437 7.21363C10.0887 7.21363 10.6487 7.82905 10.6662 8.62967C10.6662 9.41426 10.0887 10.0486 9.13792 10.0486ZM20.9271 20.292H18.0921V15.2359C18.0921 14.059 17.6808 13.2599 16.6556 13.2599C15.8725 13.2599 15.4073 13.8009 15.2017 14.3215C15.1258 14.5068 15.1069 14.7693 15.1069 15.0303V20.2905H12.2704V14.078C12.2704 12.939 12.234 11.9868 12.196 11.1672H14.6592L14.789 12.4345H14.8458C15.2192 11.8395 16.1335 10.9615 17.6633 10.9615C19.5285 10.9615 20.9271 12.2113 20.9271 14.8976V20.292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.ba66936dc14c0d0616375d3a9ad7d156.svg";
export { ForwardRef as ReactComponent };